import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/config/router/routes'
import initNavigationGuards from '@/config/router/navigationsGuards/navigationGuards'

const assetRecoveryLogPrefix = '[bc-asset-recovery]'

const recoverMissingAsset = (nextPath?: string, source = 'router') => {
  const assetRecovery = (window as Window & {
    __BC_RECOVER_MISSING_ASSET__?: (targetPath?: string, context?: Record<string, unknown>) => Promise<void> | void
  }).__BC_RECOVER_MISSING_ASSET__

  if (typeof assetRecovery === 'function') {
    console.warn(assetRecoveryLogPrefix, 'Delegating recovery to asset recovery script', { nextPath, source })
    void assetRecovery(nextPath, { source })
    return
  }

  if (nextPath) {
    console.warn(assetRecoveryLogPrefix, 'Asset recovery script unavailable, using location.assign fallback', { nextPath, source })
    window.location.assign(nextPath)
    return
  }

  console.warn(assetRecoveryLogPrefix, 'Asset recovery script unavailable, using location.reload fallback', { source })
  window.location.reload()
}

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.onError((error, to) => {
  const message = error?.message || ''
  if (
    message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed')
    || message.includes('error loading dynamically imported module')
    || message.includes('is not a valid JavaScript MIME type')
  ) {
    console.warn(assetRecoveryLogPrefix, 'Router error matched missing asset recovery pattern', {
      message,
      to: to.fullPath,
    })
    recoverMissingAsset(to.fullPath, 'router.onError')
  }
})

window.addEventListener('vite:preloadError', () => {
  console.warn(assetRecoveryLogPrefix, 'Router received vite:preloadError event')
  recoverMissingAsset(undefined, 'router.vite:preloadError')
})

const routerWithNavigationGuards = initNavigationGuards(router)

export default routerWithNavigationGuards
